import React from 'react'
import { Box } from 'native-base'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import LocalizationContext from '../../context/LocalizationContext'
import Loading from '../../components/basic/Loading'
import ReservationCalendar from '../../components/ReservationCalendar'
import moment from 'moment'
import _ from 'lodash'

function ReservationCalendarScreen(props) {
    const { t } = React.useContext(LocalizationContext)
    const { navigation, reservationStore } = props
    const [isLoading, setIsLoading] = React.useState(true)
    const [reservationItems, setReservationItems] = React.useState({})
    const [selectedMonth, setSelectedMonth] = React.useState(moment().format('MMMM'))
    const startDate = moment().format('YYYY-MM-DD')
    const endDate = moment().add(2, 'months').format('YYYY-MM-DD')


    const getDateArrays = (startDate, endDate) => {
        let dateArrays = []
        let currentDate = startDate
        dateArrays.push(moment(currentDate).format('YYYY-MM-DD'))
        while (moment(currentDate).isBefore(moment(endDate))) {
            currentDate = moment(currentDate).add(1, 'days')
            dateArrays.push(moment(currentDate).format('YYYY-MM-DD'))
        }
        return dateArrays
    }

    React.useEffect(() => {
        const componentDidMount = async () => {
            try {
                await reservationStore.listReservationSummary(Date.now())
                let _reservationItems = _.groupBy(
                    toJS(reservationStore.reservationSummary).map((f) => {
                        f.date = moment(f.time).format('YYYY-MM-DD')
                        return f
                    }),
                    'date')
                const dateArrays = getDateArrays(startDate, endDate)
                for (const date of dateArrays) {
                    if (!_reservationItems.hasOwnProperty(date)) {
                        _reservationItems[date] = []
                    }
                }
                setReservationItems(_reservationItems)
            }
            catch (e) {
                console.log(e)
            }
            setIsLoading(false)
        }

        componentDidMount()
    }, [navigation])

    const handleLoadItems = async (date) => {
        if (!reservationItems.hasOwnProperty(date.dateString)) {
            reservationItems[date.dateString] = []
            setReservationItems(reservationItems)
        }
    }


    if (isLoading) {
        return <Loading />
    }


    console.log(toJS(reservationStore.reservationSummary))
    console.log(reservationItems)
    return (
        <ReservationCalendar
            t={t}
            startDate={startDate}
            endDate={endDate}
            reservationItems={reservationItems}
            loadItems={(date) => handleLoadItems(date)}
            selectedMonth={selectedMonth}
            onDayChange={(day) => setSelectedMonth(moment().month(day.month - 1).format('MMMM'))}
            onItemPress={(productId, time) => { return navigation.push('ReservationList', { productId, time }) }}
        />
    )
}

export default inject('reservationStore')(observer(ReservationCalendarScreen))